import React from 'react';
import PolicyHeader from './PolicyHeader';
import Footer from './Footer';
import './RefundPolicy.css';

export default function RefundPolicy({ setIsLoginOpen, setIsSignupOpen, openEnroll }) {
  return (
    <div className="policy-container">
      <PolicyHeader />
      <main className="policy-content">
        <h1>Refund Policy</h1>
        <p>Thank you for choosing kodez.robokalam.in</p>
        <ul>
          <li>Non-tangible irrevocable goods ("Digital products")</li>
          <li>We do not issue refunds for non-tangible irrevocable goods ("digital products") once the order is confirmed and the product is sent.</li>
          <li>We recommend contacting us for assistance if you experience any issues receiving or downloading our products.</li>
        </ul>
        <h3>Contact us for any issues:</h3>
        <p>
          If you have any questions about our Returns and Refunds Policy,
          please contact us at: <a href="mailto:team@robokalam.com">team@robokalam.com</a>
        </p>
      </main>
      <Footer openEnroll={openEnroll}/>
    </div>
  );
}
